/**
 * @param   {String} forIdentifier
 * @returns {Object}
 */
function genProps(forIdentifier) {
  if (forIdentifier) {
    return {
      testID: forIdentifier,
      // https://github.com/facebook/draft-js/blob/70178257f60c2bdb79b1b208cf8b7bbce09ab15e/src/component/base/DraftEditorProps.js#L103
      webDriverTestID: forIdentifier,
      "data-test-id": forIdentifier,
    };
  }

  return {};
}

/**
 * @param   {String} actualIdentifier
 * @returns {Object}
 */
export default function testId(actualIdentifier) {
  if (process.env.NODE_ENV !== "test") {
    return {};
  }

  if (typeof actualIdentifier === "string") {
    return genProps(actualIdentifier);
  }

  return {};
}
